/**
 * Add a CSS class to an HTML element
 * @param element HTML Element
 * @param className Name of CSS class to add
 */
export function addClass(element: HTMLElement, className: string): void {
    if (!element.classList.contains(className)) {
        element.classList.add(className);
    }
}